export default {
    empresa: {
        id: '',
        cnpj: '',
        endereco: {
            bairro: '',
            cep: '',
            cidade: '',
            estado: '',
            logradouro: '',
            numero: '',
        },
        nome: '',
        nomefantasia: '',
        telefones: []
    },
    usuarios: [],
    permissoes: [],
    grupos: []
}



// WEBPACK FOOTER //
// ./src/store/modules/usuario/state.js